import React from 'react';
import { Stack, useThemedValueSwitch } from '@tq/ui-components';
import { ToggleButton, ToggleButtonGroup } from 'components';
import { useTranslation } from 'react-i18next';
import { ConsultationNoteTypes } from 'types';

export type NotesFilter = 'All' | ConsultationNoteTypes;
export interface NotesFilterButtonsProps {
  activeFilter: NotesFilter;
  onChangeActiveFilter: (filter: NotesFilter) => void;
}
export const NotesFilterButtons: React.FC<NotesFilterButtonsProps> = ({
  activeFilter,
  onChangeActiveFilter,
}) => {
  const { t } = useTranslation('notes');
  const { tvs } = useThemedValueSwitch();
  return (
    <Stack direction='row' spacing={3}>
      <ToggleButtonGroup value={activeFilter} gridGap={4}>
        <ToggleButton
          p={tvs({ tq: '.625rem 2.875rem' })}
          value='All'
          onClick={() => onChangeActiveFilter('All')}
          variant='tertiary'
        >
          {t('all', 'All')}
        </ToggleButton>
        <ToggleButton
          p={tvs({ tq: '.625rem 1.6875rem' })}
          value='Internal'
          variant='tertiary'
          onClick={() => onChangeActiveFilter('Internal')}
        >
          {t('internal', 'Internal')}
        </ToggleButton>
        <ToggleButton
          p={tvs({ tq: '.625rem' })}
          value='External'
          variant='tertiary'
          onClick={() => onChangeActiveFilter('External')}
        >
          {t('external', 'External')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};
